// Universell avatar-komponent.
// Viser profilbilde hvis tilgjengelig, faller tilbake til emoji eller initialer.
import React from 'react';

export default function UserAvatar({ photo, emoji, name, color, size = 36, style = {} }) {
  const initials = name
    ? name.trim().split(/\s+/).map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: color || '#7C6FF7',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      overflow: 'hidden', flexShrink: 0, fontWeight: 700,
      ...style,
    }}>
      {photo
        ? <img src={photo} alt={name || ''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : <span style={{ fontSize: size * 0.4, color: '#fff', lineHeight: 1 }}>{emoji || initials}</span>
      }
    </div>
  );
}
